
export default {
  name: 'InsuranceModal',
  props: {
    eventCurrency: {
      type: String,
      required: true
    },
    cartCurrency: {
      type: String,
      required: true
    }
  },
  methods: {
    clear() {
      this.$store.dispatch('cart/EXPIRE').then(() => {
        this.$emit('close')
      })
    },
    accept() {
      this.$router.push(this.localePath({ name: 'payment' }))
      this.$emit('close')
    }
  }
}
